<div class="questionContainer">
  <div class="titleContainer">
    <div class="title">{{ question.question_content }}</div>
  </div>
  <div class="contentContainer">
    @if (videoUrl !== null) {
      <div class="videoContainer">
        <video class="video" controls playsinline webkit-playsinline preload="metadata" [src]="videoUrl"></video>
      </div>
    } @else {
      <div class="illusContainer">
        <img [src]="getIllusSrc()" draggable="false" />
      </div>
    }
    <div class="answersContainer">
      @if (showAnswers) {
        @for (answer of question.answers; track answer; let i = $index) {
          <div (click)="toggleAnswer(i)" class="answer" [class.active]="isActive(i)" [style.animation-delay]="getAnswerAnimationDelay(i)">
            <div class="number">{{ i + 1 }}</div>
            <div class="textContainer">
              <div class="text">{{ answer }}</div>
            </div>
          </div>
        }
      }
    </div>
  </div>
</div>
